export enum GA4EventName {
  ADD_OWN_AUDIO = 'AddOwnAudio',
  ADD_SLIDESHOW = 'AddSlideshow',
  START_DRAWING = 'StartDrawing',
  GETTY_IMAGE_LIMIT_REACHED = 'GettyImageLimitReached',
  EXTRACTED_GETTY_STICKER_LIMIT_REACHED = 'ExtractedGettyLimitReached',
  GETTY_VIDEO_LIMIT_REACHED = 'GettyVideoLimitReached',
  VIDEO_LIMIT_DIALOG = 'VideoLimitDialog',
  REMOVE_BACKGROUND = 'RemoveBackground',
  REMOVE_BACKGROUND_VIDEO = 'RemoveBackgroundVideo',
  SEARCH_BACKGROUND = 'SearchBackground',
  SEARCH_STORYBLOCKS_ILLUSTRATIONS = 'StoryblocksIllustrationsSearch',
  SEARCH_PIXABAY_ILLUSTRATIONS = 'PixabayIllustrationsSearch',
  ADDED_SLIDESHOW_ANIMATION = 'AddedSlideshowAnimation',
  ADDED_POSTER_ANIMATION = 'AddedPosterAnimation',
  ANIMATION_ITEM_ENTRANCE = 'Animation_Item_Entrance',
  ANIMATION_ITEM_EXIT = 'Animation_Item_Exit',
  ANIMATION_DESIGN_ENTRANCE = 'Animation_Design_Entrance',
  ANIMATION_DESIGN_EXIT = 'Animation_Design_Exit',
  CREATE_POSTER = 'CreatePoster',
  UPLOAD_FONT = 'UploadFont',
  DIGITAL_DISPLAY_PUBLISHED = 'DigitalDisplayPublished',
  EDITOR_ONBOARDING_VISITED = 'EditorOnboarding_Visited',
  EDITOR_ONBOARDING_SKIPPED = 'EditorOnboarding_Skipped',
  DOWNLOAD_CAMPAIGN_PDF = 'EmailPerformance_DownloadCampaign_PDF',
  DOWNLOAD_CAMPAIGN_CSV = 'EmailPerformance_DownloadCampaign_CSV',
  DOWNLOAD_MAILING_LIST_CSV = 'EmailPerformance_DownloadMailingList',
  ACCOUNT_ADDED = 'AccountAdded',
  ACCOUNT_DELETED = 'AccountDeleted',
  ACCOUNT_ADDED_MYSTUFF = 'AccountAdded_MyStuff',
  POST_PUBLISHED = 'PostPublished',
  POST_SCHEDULED = 'PostScheduled',
  PUBLISHING_INTRO_VIDEO = 'PublishingIntroVideo',
  PUBLISHING_ONBOARDING = 'PublishingOnboarding',
  MYSTUFF_SOCIALPOSTS_CREATEDESIGN = 'MyStuff_SocialPosts_CreateDesign',
  SOCIALWIZARD_ACCOUNTADDED = 'SocialWizard_AccountAdded',
  SOCIALWIZARD_NUMPLATFORMS = 'SocialWizard_NumPlatforms',
  SOCIALWIZARD_EDITDESIGN = 'SocialWizard_EditDesign',
  SOCIALWIZARD_RESIZEOPTIONS = 'SocialWizard_ResizeOptions',
  SOCIALWIZARD_AUTORESIZE = 'SocialWizard_AutoResize',
  MEDIA_MODAL_OPEN = 'MediaModal_Open',
  UPLOADS_MODAL_OPEN = 'UploadsModal_Open',
  EMAILMAKER_EMBEDVIDEO = 'EmailMaker_EmbedVideo',
  SOCIALWIZARD_AICAPTIONS_CLICKED = 'SocialWizard_AICaptions_Clicked',
  SOCIALWIZARD_AICAPTIONS_ADDED = 'SocialWizard_AICaptions_Added',
  SOCIALWIZARD_AICAPTIONS_FIRSTGEN = 'SocialWizard_AICaptions_FirstGen',
  SOCIALWIZARD_AICAPTIONS_MOREIDEAS = 'SocialWizard_AICaptions_MoreIdeas',
  SOCIALWIZARD_AICAPTIONS_STARTOVER = 'SocialWizard_AICaptions_StartOver',
  SOCIALWIZARD_AICAPTIONS_ONBOARDING_TRYNOW = 'SocialWizard_AICaptions_Onboarding_TryNow',
  SOCIALWIZARD_AICAPTIONS_ONBOARDING_LATER = 'SocialWizard_AICaptions_Onboarding_Later',
  SOCIALWIZARD_AICAPTIONS_REMINDER_VISIBLE_CLICK = 'SocialWizard_AICaptions_Clicked_Popover',
  SOCIALWIZARD_AICAPTIONS_RECENTS = 'SocialWizard_AICaptions_Recents',
  SOCIALWIZARD_AICAPTIONS_UPSELLING = 'SocialWizard_AICaptions_Upselling',
  SOCIALWIZARD_AICAPTIONS_LIMIT_REACHED = 'SocialWizard_AICaptions_DailyLimitHit',
  SOCIALWIZARD_AICAPTIONS_AUTOCAPTIONGEN = 'SocialWizard_AICaptions_AutoCaptionGeneration',
  SOCIALWIZARD_UPLOADMEDIA_CLICKED = 'SocialWizard_UploadMedia_Clicked',
  SOCIALWIZARD_UPLOADMEDIA_CREATED = 'SocialWizard_UploadMedia_Created',
  TEMPLATES_MENU_OPEN = 'TemplatesMenu_Open',
  EDITOR_TEMPLATE_ADD = 'EditorTemplate_Add',
  EDITOR_TRY_MENU = 'Editor_TryMenu',
  EDITOR_TRY_STICKER = 'Editor_TrySticker',
  EDITOR_TRY_ANIMATION = 'Editor_TryAnimation',
  EDITOR_TRY_STYLE = 'Editor_TryStyle',
  EDITOR_DOWNLOAD_QR = 'Editor_DownloadQR',
  TEMPLATES_MENU_ADD_AFTER_NEW_POSTER = 'TemplatesMenu_Add_After_New_Poster',
  TEMPLATES_MENU_CLOSE_AFTER_NEW_POSTER = 'TemplatesMenu_Close_After_New_Poster',
  TEXT_MENU_OPEN = 'TextMenu_Open',
  LAYOUT_MENU_OPEN = 'LayoutMenu_Open',
  SLIDESHOW_MENU_OPEN = 'SlideshowMenu_Open',
  BACKGROUND_MENU_OPEN = 'BackgroundMenu_Open',
  QR_CODE_ADDED = 'AddedQRCode',
  TEXT_ITEM_ADDED = 'AddedTextItem',
  MORE_OPTIONS_OPEN = 'MoreOptions_Open',
  RECORD_MENU_OPEN = 'RecordMenu_Open',
  DESIGNS_MENU_OPEN = 'DesignsMenu_Open',
  UPLOADSMODAL_RECORDED_MEDIA = 'UploadsModal_RecordedMedia',
  UPLOADSMODAL_RECORDED_MEDIA_ADDED = 'UploadsModal_RecordedMedia_Added',
  UPLOADSMODAL_UPLOAD_MEDIA = 'UploadsModal_UploadMedia',
  EMAILMAKER_UPLOAD_MEDIA = 'EmailMaker_UploadMedia',
  DESIGNER_PROFILE_CLICK = 'DesignerProfileClick_PosterBuilder',
  AI_IMAGE_MENU_OPEN = 'AIImageMenu_Open',
  AI_TEXT_MENU_OPEN = 'TextMenu_AITextOpen',
  AI_IMAGE_MENU_GENERATE = 'AIImageMenu_Generate',
  AI_IMAGE_MENU_MODEL = 'AIImageMenu_Model',
  AI_IMAGE_TOTAL_GENERATIONS = 'AIImage_TotalGenerations',
  MEDIA_MODAL_AI_IMAGE_GENERATE_YOUR_OWN = 'MediaModal_AIImage_GenerateYourOwn',
  MEDIA_MODAL_AI_IMAGE_VIEW_ALL = 'MediaModal_AIImage_ViewAll',
  MEDIA_MODAL_AI_IMAGE_GENERATE = 'MediaModal_AIImage_Generate',
  MediaModal_AudioFilters = 'MediaModal_AudioFilters',
  MediaModal_ShapeFilter = 'MediaModal_ShapeFilter',
  CREATE_DESIGN_FROM_MEDIA_CLICKED = 'CreatePosterFromUpload_Clicked',
  CREATE_DESIGN_FROM_MEDIA_CREATED = 'CreatePosterFromUpload_Created',
  CONTENTPLANNER_ADD_EMAIL = 'ContentPlanner_AddEmail',
  CONTENTPLANNER_ADD_SOCIAL_POST = 'ContentPlanner_AddSocialPost',
  CONTENTPLANNER_ADD_CUSTOM_EVENT = 'ContentPlanner_AddCustomEvent',
  EMAILMAKER_SUBJECT_LINE_AI_WRITER_CLICKED = 'EmailMaker_SubjectLine_AIWriter_Clicked',
  EMAILMAKER_SUBJECT_LINE_AI_WRITER_GENERATED = 'EmailMaker_SubjectLine_AIWriter_Generated',
  TIMELINE_OPEN = 'Timeline_Open',
  TIMELINE_DEFAULT_OPTION_CLICKED = 'Timeline_Default_Option_Clicked',
  TIMELINE_OPEN_BOTTOM_BAR = 'Timeline_Open_BottomBar',
  TIMELINE_OPEN_AUDIO_ICON = 'Timeline_Open_AudioIcon',
  TRIM_AUDIO_TIMELINE = 'TrimAudio_Timeline',
  TRIM_VIDEO_TIMELINE = 'TrimVideo_Timeline',
  EDITOR_DURATION_SELECTOR_CLICKED = 'Editor_Duration_Selector_Clicked',
  TRIM_AUDIO_MODAL = 'TrimAudio_Modal',
  TRIM_VIDEO_MODAL = 'TrimVideo_Modal',
  SIGN_UP_GOOGLE = 'Google',
  SIGN_UP_FACEBOOK = 'Facebook',
  SIGN_UP_APPLE = 'Apple',
  EMAILMAKER_STYLES_VISITED = 'EmailMaker_Styles_Visited',
  EMAILMAKER_STYLES_APPLIED = 'EmailMaker_Styles_Applied',
  EMAILMAKER_STYLES_SEARCHED = 'EmailMaker_Styles_Searched',
  EMAILMAKER_STYLES_PILLS = 'EmailMaker_Styles_Pills',
  EMAILMAKER_SMARTMAILINGLIST = 'Emailmaker_SmartMailingList',
  EMAILMAKER_SENDCAMPAIGN_SMART_MAILING_LIST = 'Emailmaker_sendcampaign_smartmailinglist',

  EMAILMAKER_AI_EDIT_CLICKED = 'EmailMaker_AIEdit_Clicked',

  EDITOR_STYLES_VISITED = 'Editor_Styles_Visited',
  EDITOR_STYLES_APPLIED = 'Editor_Styles_Applied',
  EDITOR_STYLES_SEARCHED = 'Editor_Styles_Searched',
  EDITOR_STYLES_PILLS = 'Editor_Styles_Pills',
  EDITOR_STYLES_PALETTE_SHUFFLED = 'Editor_Styles_Palette_Shuffled',
  EDITOR_AIREWRITE_CLICK = 'Editor_AIRewrite_Click',
  EDITOR_AIREWRITE_MOOD = 'Editor_AIRewrite_Mood',
  EDITOR_AIREWRITE_EMOJIS = 'Editor_AIRewrite_Emojis',
  EDITOR_AIREWRITE_APPLIED = 'Editor_AIRewrite_Applied',
  EDITOR_AIREWRITE_SETTINGS = 'Editor_AIRewrite_Settings',
  EDITOR_AIREWRITE_PRESET = 'Editor_AIRewrite_Preset',
  AI_REDESIGN_OPENED = 'AI_REDESIGN_OPENED',

  EMAILMAKER_ADD_SECTION = 'EmailMaker_AddSection',
  EMAILMAKER_SECTION_SELECT = 'EmailMaker_SectionSelect',
  EMAILMAKER_SECTION_SAVE = 'EmailMaker_SectionSave',
  EMAILMAKER_SAVED_SECTION_SELECT = 'EmailMaker_SavedSectionSelect',
  EMAILMAKER_ADD_ELEMENT = 'EmailMaker_AddElement',
  EMAILMAKER_SECTIONS_PUBLISHED = 'EmailMaker_SectionsPublished',

  EMAILMAKER_MAILINGLIST = 'EmailMaker_MailingList',
  EMAILMAKER_MAILINGLIST_MYSTUFF_TOPBUTTON = 'EmailMaker_MailingList_MyStuff_TopButton',
  EMAILMAKER_MAILINGLIST_MYSTUFF_PLUSBUTTON = 'EmailMaker_MailingList_MyStuff_PlusButton',
  EMAILMAKER_MAILINGLIST_MYSTUFF_BANNER = 'EmailMaker_MailingList_MyStuff_Banner',
  EMAILMAKER_MAILINGLIST_SIGNUP_FORM = 'EmailMaker_MailingList_SignUpForm',
  EMAILMAKER_AUTO_MAILING_LIST = 'EmailMaker_Auto_MailingList',
  EMAILMAKER_SEND_CAMPAIGN_AUTO_MAILING_LIST = 'EmailMaker_Send_Campaign_Auto_MailingList',
  SIGNUPFORM_CREATE = 'SignUpForm_Create',
  SIGNUPFORM_CREATE_MYSTUFF_TOPBUTTON = 'SignUpForm_Create_MyStuff_TopButton',
  SIGNUPFORM_CREATE_MYSTUFF_PLUSBUTTON = 'SignUpForm_Create_MyStuff_PlusButton',
  SIGNUPFORM_CREATE_MYSTUFF_BANNER = 'SignUpForm_Create_MyStuff_Banner',
  SIGNUPFORM_DEFAULT_FIELDS_TOGGLE = 'SignUpForm_DefaultFieldsToggle',
  SIGNUPFORM_CUSTOM_FIELDS_TOGGLE = 'SignUpForm_CustomFieldsToggle',
  BUSINESS_PROFILES_IMPORT = 'BusinessProfiles_Import',
  BUSINESS_PROFILES_CREATE = 'BusinessProfiles_Create',
  BUSINESS_PROFILES_COMPLETE = 'BusinessProfiles_Complete',
  MENU_MAKER_FROM_ADD_TEXT_MENU = 'MenuMakerFromAddTextMenu',
  MENU_MAKER_FROM_CANVAS_EDIT_BUTTON = 'MenuMakerFromCanvasEditButton',
  AI_SUBTITLE_CLICK_MENU = 'AISubtitle_Click_Menu',
  AI_SUBTITLE_CLICK_CONTEXTUAL_MENU = 'AISubtitle_Click_Contextual',
  AI_SUBTITLE_GENERATE = 'AISubtitles_Generate',
  AI_SUBTITLE_TEMPLATE_PRESET_SELECTED = 'AISubtitles_Template_Preset_Selected',

  COPY_STYLES_CLICKED = 'CopyStyles_Clicked',

  EMAILMAKER_MERGE_TAGS_ADDED = 'EmailMaker_MergeTags_Added',
  EMAILMAKER_MERGER_TAGS_IN_CAMPAIGN = 'EmailMaker_MergeTags_Campaign_Sent',
  CREATE_MODAL_BROWSE_DESIGN_TEMPLATES = 'CreateBottomBar_Designs_Browse',
  CREATE_MODAL_BLANK_DESIGN = 'CreateBottomBar_Designs_Blank',
  CREATE_MODAL_BROWSE_EMAIL_TEMPLATES = 'CreateBottomBar_Emails_Browse',
  CREATE_MODAL_BLANK_EMAIL = 'CreateBottomBar_Emails_Blank',
  AI_VOICE_GENERATED = 'AIVoice_Generated',
  AI_VOICE_ADDED = 'AIVoice_Added',
  AI_VOICE_COPY_PROMPT = 'AIVoice_CopyPrompt',
  AI_IMAGE_ADDED = 'AIImage_Added',
  AI_VIDEO_MENU_OPEN = 'AIVideoMenu_Open',
  AI_VIDEO_GENERATE = 'AIVideoMenu_Generate',
  AI_VIDEO_ADDED = 'AIVideo_Added',
  AI_VOICE_LIMIT_REACHED = 'AIVoice_LimitReached',
  BUSINESS_PROFILES_EMAIL_EDITOR_SOCIAL_LINK = 'BP_EmailEditor_SocialLink',
  BUSINESS_PROFILES_DESIGN_EDITOR_SOCIAL_LINK = 'BP_DesignEditor_SocialLink',
  BUSINESS_PROFILES_DESIGN_EDITOR_QR_CODE = 'BP_DesignEditor_QRCode',
  BUSINESS_PROFILES_DESIGN_EDITOR_SCHEDULE = 'BP_DesignEditor_Schedule',
  BRANDKITS_NEW_GET_FROM_WEBSITE = 'BrandKits_New_GetFromWebsite',
  BRANDKITS_NEW_START_FROM_SCRATCH = 'BrandKits_New_StartFromScratch',
  BUSINESS_PROFILE_POST_ON_GBP = 'BusinessProfile_PostonGBP',
  BUSINESS_PROFILE_EDIT = 'BusinessProfile_Edit',
  AI_IMAGE_PROMPT_COPY = 'AIImage_PromptCopy',
  EVENTS_AICHAT_ENTRY = 'Events_AIChat_Entry',
  EVENTS_AICHAT_CHANGE_STYLE = 'Events_AIChat_ChangeStyle',
  EVENTS_CREATE_BANNER_CLICK = 'Events_Create_Banner_Click',
  EVENTS_CREATE_CLICK = 'Events_Create_Click',
  EVENTS_CREATE_COMPLETE = 'Events_Create_Complete',
  EVENTS_TAB_MYSTUFF_CALENDAR_EDIT = 'Events_Tab_MyStuff_Calendar_Edit',
  EVENTS_TAB_MYSTUFF_CALENDAR_COPY_LINK = 'Events_Tab_MyStuff_Calendar_CopyLink',
  EVENTS_TAB_MYSTUFF_CALENDAR_EMBED = 'Events_Tab_MyStuff_Calendar_Embed',
  EVENTS_TAB_MYSTUFF_CLICK = 'Events_Tab_MyStuff_Click',
  EVENTS_EMBED_WORDPRESS_CLICK = 'Events_Calendar_Wordpress_Embed',
  EVENTS_UPDATE_CLICK = 'Events_Update_Click',
  EVENTS_CREATE_RECURRING = 'Events_Create_Recurring',
  EVENTS_CREATE_VENUE = 'Events_Create_Venue',
  EVENTS_CREATE_SHARE_TEAM = 'Events_Create_Share_Team',
  EVENTS_PAGE_SOCIALS = 'Events_Page_Socials',
  EVENTS_CREATE_VISUALS = 'Events_Create_Visuals',
  EVENTS_APPLY_BRAND_KIT = 'Events_Create_BrandKit',
  EVENT_WIZARD_COMPLETE_FIRST_STEP = 'Events_Create_Next_Step2',
  EVENT_WIZARD_APPLY_COLOR = 'Events_Create_Style',
  EVENT_WIZARD_APPLY_FONT = 'Events_Create_Font',
  EVENT_WIZARD_AI_TYPE_SELECTED = 'Events_Create_Type_AI',
  EVENTS_UPSELLING_DIALOG = 'Events_UpsellingDialog',
  EVENTS_MYSTUFF_SCHEDULE_ADD_TO_WEBPAGE = 'Events_MyStuff_Schedule_AddToWebpage',
  EVENTS_MYSTUFF_ALLOW_REGISTRATIONS = 'Events_MyStuff_Allow_Registrations',
  EVENTS_MYSTUFF_CREATE = 'Events_MyStuff_Create',
  EVENTS_MYSTUFF_DELETE = 'Events_MyStuff_Delete',
  EVENTS_MYSTUFF_DUPLICATE = 'Events_MyStuff_Duplicate',
  EVENTS_MYSTUFF_PREVIEW = 'Events_MyStuff_Preview',
  EVENTS_ONE_CLICK_PROMO_BUTTON = 'Events_One_Click',
  EVENTS_MYSTUFF_VIEW_CHANGE = 'Events_MyStuff_View',
  EVENTS_PROMOTE_EMAIL = 'Events_Promote_Email',
  EVENTS_PROMOTE_SOCIAL = 'Events_Promote_Social',
  EVENTS_MANAGE_ATTENDEES_EDIT = 'Events_Manage_Attendees_Edit',
  EVENTS_MANAGE_INVITE_COPY = 'Events_Manage_Invite_Copy',
  EVENTS_MANAGE_INVITE_EMAIL = 'Events_Manage_Invite_Email',
  EVENTS_MANAGE_PAGE_EDIT = 'Events_Manage_Page_Edit',
  EVENTS_MANAGE_REMINDER = 'Events_Manage_Reminder',
  EVENTS_MANAGE_REMINDER_SAVE = 'Events_Manage_Reminder_Save',
  EVENTS_MANAGE_SIGNUP_EDIT = 'Events_Manage_Signup_Edit',
  EVENTS_SHARE_TEAM_EXTERNAL = 'Events_Share_Team_External',
  EVENTS_ONE_CLICK_PUBLISH = 'Events_One_Click_Publish',
  EVENTS_ONE_CLICK_EMAIL_EDIT_CLICK = 'Events_One_Click_Email_Edit',
  EVENTS_ONE_CLICK_SOCIAL_EDIT_CLICK = 'Events_One_Click_Social_Edit',
  EVENTS_PROMOTE_EMBED = 'Events_Promote_Embed',
  EVENTS_PROMOTE_EVENT_PAGE_SHARE = 'Events_Promote_Event_Page_Share',
  EVENTS_PROMOTE_EMAIL_SKIP = 'Events_Promote_Email_Skip',
  EVENTS_PROMOTE_SOCIAL_SKIP = 'Events_Promote_Social_Skip',
  EVENTS_PROMOTE_EMBED_SKIP = 'Events_Promote_Embed_Skip',
  EVENTS_PROMOTE_PRINT_SKIP = 'Events_Promote_Print_Skip',
  EVENTS_PROMOTE_PAGE_SHARE_SKIP = 'Events_Promote_Event_Page_Share_Skip',
  EVENTS_PROMOTE_COPY_PAGE_LINK = 'Events_Promote_Copy_Page_Link',
  EVENTS_SCHEDULE_APPLY_BRAND_KIT = 'Events_Schedule_BrandKit',
  EVENTS_SCHEDULE_APPLY_COLOR = 'Events_Schedule_Style',
  EVENTS_SCHEDULE_APPLY_FONT = 'Events_Schedule_Font',
  EVENTS_SCHEDULE_ADD_LOGO = 'Events_Schedule_Logo',
  EVENTS_SCHEDULE_UPLOAD_COVER = 'Events_Schedule_Cover',
  EVENTS_SCHEDULE_CREATE_EVENT = 'Events_Schedule_Create',
  EVENTS_SCHEDULE_EDIT = 'Events_Schedule_Edit',
  EVENTS_CALENDAR_EDIT = 'Events_Calendar_Edit',
  EVENTS_SCHEDULE_EMBED = 'Events_Schedule_Embed',
  EVENTS_SCHEDULE_EMAIL = 'Events_Schedule_Email',
  EVENTS_SCHEDULE_PHONE_NUMBER = 'Events_Schedule_PhoneNumber',
  EVENTS_SCHEDULE_SOCIALS = 'Events_Schedule_Socials',
  EVENTS_PROMOTE_PRINT_FLYER_DOWNLOAD = 'Events_Promote_Print',
  EVENTS_PROMOTE_CLICK = 'Events_Promote_Click',
  EVENTS_MANAGE_CLICK = 'Events_Manage_Click',
  EVENTS_CREATE_LOGIN_CLICK = 'Events_Create_Login_Click',
  EVENTS_PROMOTE_SOCIAL_PUBLISH = 'Events_Promote_Social_Publish',
  EVENTS_PROMOTE_SOCIAL_SCHEDULE = 'Events_Promote_Social_Schedule',
  EVENTS_COPROMOTER_INVITED = 'Events_Copromoter_invited',
  EVENTS_COPROMOTER_JOINED = 'Events_Copromoter_joined',
  EVENTS_CALENDAR_PROMOTE_EMBED = 'Events_Calendar_Promote_Embed',
  EVENTS_INDIVIDUAL_PROMOTE_EMBED = 'Events_Individual_Promote_Embed',

  COLLABORATION_DESIGN_SHAREINTEAM = 'Collab_Design_Shareinteam',
  COLLABORATION_DESIGN_INVITEBYEMAIL = 'Collab_Design_Inviteemail',
  COLLABORATION_DESIGN_INVITELINK = 'Collab_Design_Invitelink',
  COLLABORATION_DESIGN_INVITEBYEMAIL_RECOMMENDATION = 'Collab_Design_Inviteemail_Recommendation',
  COLLABORATION_DESIGN_ACCESSLEVEL = 'Collab_Design_Accesslevel',
  COLLABORATION_DESIGN_SHAREDWITHME_FILTER = 'Collab_Design_Sharedwithme_Filter',
  COLLABORATION_DESIGN_LANDING_PAGE_NAV_LOGIN_CLICKED = 'Collab_Design_LP_Nav_Login',
  COLLABORATION_FOLDER_SHAREINTEAM = 'Collab_Folder_Shareinteam',
  COLLABORATION_FOLDER_INVITEBYEMAIL_SHAREDIALOG = 'Collab_Folder_Shareinteam_Inviteemail',
  COLLABORATION_FOLDER_INVITELINK_SHAREDIALOG = 'Collab_Folder_Shareinteam_Invitelink',
  COLLABORATION_FOLDER_INVITEBYEMAIL_RECOMMENDATION = 'Collab_Folder_Inviteemail_Recommendation',
  COLLABORATION_FOLDER_ACCESSLEVEL = 'Collab_Folder_Accesslevel',
  COLLABORATION_FOLDER_LANDING_PAGE_NAV_LOGIN_CLICKED = 'Collab_Folder_LP_Nav_Login',
  COLLAB_EMAIL_SHAREINTEAM = 'Collab_Email_Shareinteam',
  COLLAB_MAILINGLIST_SHAREINTEAM = 'Collab_MailingList_Shareinteam',
  COLLAB_SIGNUPFORM_SHAREINTEAM = 'Collab_SignupForm_Shareinteam',
  COLLABORATION_SOCIALPOST_SHAREINTEAM_MYSTUFF = 'Collaboration_SocialPost_Shareinteam_MyStuff',
  COLLABORATION_SOCIALPOST_SHAREINTEAM_WIZARD = 'Collaboration_SocialPost_Shareinteam_Wizard',
  COLLABORATION_SOCIALACCOUNT_SHAREINTEAM_MYSTUFF = 'Collaboration_SocialAccount_Shareinteam_MyStuff',
  HALLOWEEN_2025_BRAND_KIT_USE = 'Halloween25_BrandKitUse',
  BRAND_KITS_PAYG_UPSELL_DIALOG = 'BrandKitsLimitDialog_PAYG',
  BRAND_KITS_PREMIUM_UPSELL_DIALOG = 'BrandKitsLimitDialog_Premium',
  EVENTS_MY_STUFF_CALENDAR_SHARE = 'Events_MyStuff_Calendar_Share',
  PUBLISHING_GENERATE_QR_CODE = 'GenerateQR',
  PUBLISHING_DOWNLOAD_QR_CODE = 'DownloadQR',
  PUBLISHING_COPY_QR_CODE = 'CopyQR',
  PUBLISHING_QUICK_QR_TEMPLATE = 'QuickQRTemplate',
  PUBLISHING_MYSTUFF_WEBLINK_UNPUBLISH = 'Mystuff_Weblink_Unpublish',
  PUBLISHING_MYSTUFF_QRLINK_UNPUBLISH = 'Mystuff_QR_Unpublish',
  VERSION_HISTORY_OPEN = 'Version_History_Open',
  VERSION_HISTORY_RESTORE = 'Version_History_Restore',
  VERSION_HISTORY_DUPLICATE = 'Version_History_Duplicate',

  NOTIFICATION_NAV_CLICK = 'Notification_Nav_Click',
  NOTIFICATION_CLICK = 'Notification_Click',
  NOTIFICATION_SETTINGS_CLICK = 'Notification_Setting_Click',
  NOTIFICATION_MARK_READ = 'Notification_Mark_Read',
  NOTIFICATION_TOGGLE = 'Notification_Toggle',

  PLAY_PAGE = 'PlayPage',
  ADD_PAGE = 'AddPage',
  SAVE_TO_DRIVE = 'SaveToDrive',
  PRINT_SHOP_LINK = 'PrintShop_Link',
  DOWNLOAD_OPTIONS = 'DownloadOptions',
  NEW_DOWNLOAD_DIALOG_OPEN = 'OpenNewDownloadDialog',
  POST_DOWNLOAD_UPSELLING_CLICK = 'PostDownload_UpsellClick',
  POST_DOWNLOAD_UPSELLING_CLOSE = 'PostDownload_UpsellClose',
  POST_DOWNLOAD_UPSELLING_OPEN = 'PostDownload_UpsellOpen',
  POST_DOWNLOAD_UPGRADE = 'DownloadDialogue_Upgrade',
  POST_DOWNLOAD_OPTIONS = 'PostDownload_Options',
  PUBLISH_NOW_DOWNLOAD_DIALOG = 'PublishNow',
  NAVBAR_SEARCH = 'Nav_Search',
  EVENTS_CALENDAR_LAYOUT_SELECTED = 'Events_Calendar_Layout_Selected',
  EVENTS_CALENDAR_SUBVIEW_CHANGED = 'Events_Calendar_Subview_Changed',
  AICHAT_DOWNLOAD = 'AIChat_Download',
  AICHAT_PUBLISH = 'AIChat_Publish',
  AICHAT_SHARE = 'AIChat_Share',
  AICHAT_OPEN_EDITOR = 'AIChat_OpenEditor',
  AICHAT_EDIT = 'AIChat_Edit',
  AICHAT_NO_CREDITS = 'AIChat_NoCredits',
  AICHAT_ALL_CHATS = 'AIChat_AllChats',
  AICHAT_START = 'AIChat_Start',
  AICHAT_HOMEPAGE = 'AIChat_Homepage',
  AICHAT_CREDITS_FINISHED = 'AIChat_CreditsFinished',
  AICHAT_SAVE_TO_MY_DESIGNS = 'AIChat_SavetoMyDesigns',
  AICHAT_EDIT_MESSAGE = 'AIChat_EditMessage',
  AICHAT_VOICE_START = 'AIChat_VoiceStart',
  AICHAT_VOICE_END = 'AIChat_VoiceEnd',
  AICHAT_VOICE_LIMIT = 'AIChat_VoiceLimit',
  AICHAT_ATTACHMENTS = 'AIChat_Attachments',
  AICHAT_QUICK_TIPS = 'AIChat_QuickTips',
  AICHAT_QUICK_TIPS_EXPAND = 'AIChat_QuickTipsExpand',
  CROP_APPLIED = 'CropApplied',
  CROP_ELEMENT = 'CropElement',
  MASK_APPLIED = 'MaskApplied',
  REPLACE_ELEMENT = 'ReplaceElement',
  TEXT_EDIT = 'TextEdit',
  ADD_BRAND_FONT = 'AddBrandFont',
  ADD_BRAND_COLOR = 'AddBrandColor',
  DESIGN_TEMPLATE_SUBMITTED = 'DesignTemplateSubmitted',
  AICHAT_TEMPLATES_VIEWMORE = 'AIChat_Templates_Viewmore',
  AICHAT_TEMPLATES_ATTACH = 'AIChat_Templates_Attach',
  AICHAT_TEMPLATES_DONTSHOW = 'AIChat_Templates_Dontshow',
  AICHAT_TURNTOVIDEO_OPENINEDITOR = 'AIChat_Turntovideo_Openineditor',
  AICHAT_TURNTOVIDEO = 'AIChat_Turntovideo',
  AICHAT_TURNTOVIDEO_DOWNLOAD = 'AIChat_Turntovideo_Download',
  AICHAT_TURNTOVIDEO_PUBLISH = 'AIChat_Turntovideo_Publish',
}

export enum AddPageGA4EventParams {
  TIMELINE = 'timeline_button',
  PAGE_BOTTOM_BUTTON = 'page_bottom',
  PAGE_RIGHT_OPTIONS = 'page_right',
  ALL_PAGES_MOBILE = 'all_pages_mobile',
  CONTEXTUAL_MENU_MOBILE = 'contextual_menu_mobile',
}

export enum GA4EventParam {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
}

export enum GA4EventTextTypeParam {
  PLAIN = 'plain',
  FANCY = 'fancy',
  TRANSCRIPT = 'transcript',
  SLIDESHOW = 'slideshow',
  TEXT_PRESET = 'textpreset',
}

export enum GA4EventParamName {
  SEARCH_TERM = 'searchTerm',
  PROMPT = 'prompt',
  TYPE = 'type',
  SLIDE_NUMBER = 'slideNumber',
  PLATFORM = 'platform',
  NUM_PLATFORMS = 'num_platforms',
  SIGNUP_PARAM_NAME = 'method',
  TERM = 'term',
  SEATS = 'seats',
  HASHED_ID = 'hashedId',
  USER_PREMIUM_LEVEL = 'userPremiumLevel',
  SOURCE = 'source',
  SIGNUP_FORM_FIELD_NAME = 'fieldName',
  SIGNUP_FORM_CUSTOM_FIELD_INDEX = 'customFieldIndex',
  MENU_OPENED_FROM = 'menuOpenedFrom',
  AI_SUBTITLE_TEMPLATE_ID = 'aiSubtitleTemplateId',
  MERGE_TAGS = 'mergeTags',
  VALUE = 'value',
  ANIMATION_TYPE = 'AnimationType',
  ITEM_TYPE = 'ItemType',
  VIEW = 'View',
  AUTO_MAILING_LIST_TYPE = 'AutoMailingListType',
}

export enum GA4EventSources {
  CONTEXTUAL_MENU = 'ContextualMenu',
  MOBILE_BOTTOM_BAR = 'BottomBar',
  LEFT_TOOLBAR = 'LeftToolbar',
  NAV_FILE_DROPDOWN = 'Dropdown',
  AUTO_SAVE_HOVER = 'Hover',
  CANVAS = 'Canvas',
}

export enum EditorMediaEvent {
  Audio_Fade_Add = 'Editor_Audio_Fade_Add',
  Audio_Fade_Removed = 'Editor_Audio_Fade_Removed',
  EDITOR_RECORDEDMEDIA_ADDED = 'Editor_RecordedMedia_Added',
  EDITOR_RECORDEDMEDIA_RETAKE = 'Editor_RecordedMedia_Retake',
}

export enum StyleType {
  BRAND_KIT = 'Brand Kit',
  ALL_STYLES = 'All Styles',
  RECENTS = 'Recents',
}

export enum GA4TemplateAddTypes {
  DEFAULT = 'Default',
  RECOMMENDED = 'Recommended',
}

export const NEW_SUBSCRIPTION_START_SOURCE_COOKIE = 'new-subscription-start-source';

export enum NewSubscriptionStartSource {
  EDITOR_UPGRADE_BUTTON = 'editor_cta',
  MY_STUFF_UPGRADE_BUTTON = 'mystuff_cta',
  PAYG_DOWNLOAD_DIALOG = 'paygdownload_dialog',
  VERSION_HISTORY_UPGRADE_BUTTON = 'versionhistory_link',
  PAYG_MULTIPAGE_LIMIT_DIALOG = 'paygmultipagelimit_downloaddialogue',
}

export enum EventUpsellGA4Source {
  MORE_EVENTS = 'moreeventpages',
  MORE_EVENTS_PREMIUM = 'morepagespremium',
  REMOVE_WATERMARK = 'removewatermark',
  DESCRIPTION_REWRITE_AI = 'rewriteaidescription',
  REGISTRATION_OPTIONS = 'guestinfo',
  RECURRING = 'recurringevents',
  NUM_GUESTS_LIMIT = 'unlimitedregistrations',
  VIEW_ANALYTICS = 'eventsmetrics',
  REMINDERS = 'reminders',
  SHARE_TEAM = 'teams',
  SIGNUP_FORM = 'signupform',
  EVENT_ONE_CLICK_PROMOTION = 'oneclickpromo',
}

export enum CollaborationGA4Source {
  MY_STUFF = 'My Stuff',
  DIALOG = 'Dialog',
  EMAIL_EDITOR = 'Email Editor',
  SIGNUPFORM_EDITOR = 'SignupForm Editor',
}

export enum CollaborationGA4Toggle {
  SHARED = 'shared',
  UNSHARED = 'unshared',
}

export enum NotificationsSettingsToggleSource {
  SM_POSTS = 'sm_posts',
  EMAILS = 'email_campaign',
  EVENTS = 'events',
  TEAM = 'team',
  DESIGN = 'design',
  ALL = 'all',
}

export enum AiChatStartSource {
  AI_HOMEPAGE = 'AI_Homepage',
  MY_STUFF = 'My_Stuff',
  TEMPLATE_PREVIEW_DIALOG = 'Template_Preview_Dialog',
  NAVBAR_PROMPT_BOX = 'Navbar_Prompt_Box',
  AI_MARKETING_PAGE = 'AI_Marketing_Page',
}

export enum AIChatHomepageSource {
  MY_STUFF = 'My_Stuff',
}

export enum AiChatTurnToVideoSource {
  AD = 'ad',
  DESIGN = 'design',
}

export enum AiChatTurnToVideoType {
  WITH_AUDIO = 'with audio',
  SILENT = 'silent',
}

export enum AiChatTurnToVideoPublishType {
  SOCIAL_MEDIA = 'social media',
  EVENT = 'event',
  EMAIL = 'email',
}

export const EMAILMAKER_ADD_SECTION_BLANK_SECTIONS = 'Empty';

export const trackPublishingGA4Events = (event: string, params?: Record<string, string>): void => {
  window.PMW.gtm.trackGA4CustomEvent(event, params);
};

export const trackPosterBuilderGA4Events = (event: string, params?: Record<string, string>): void => {
  window.PMW.gtm.trackGA4CustomEvent(event, params);
};

export const trackGA4CustomEvent = (event: string, params?: Record<string, string>): void => {
  window.PMW.gtm.trackGA4CustomEvent(event, params);
};
